import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { AcctactvtyComponent } from './acctactvty.component';

@NgModule({
  imports: [CommonModule, ProgressbarModule.forRoot()],
  declarations: [AcctactvtyComponent],
  exports: [AcctactvtyComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AcctactvtyModule {}
